const start = () => {
  document.addEventListener("click", (event) => {
    const { target } = event
    const button = target && target.closest && target.closest("[data-password-toggle]")

    if (!button) return

    const group = button.closest(".input-group")
    const input = group && group.querySelector("input")

    if (!input) return

    const hidden = input.type === "password"
    input.type = hidden ? "text" : "password"
    button.setAttribute("aria-pressed", String(hidden))

    // FontAwesome runs in SVG-JS mode, so swap which preset icon is visible
    // rather than mutating glyph classes on a rendered <svg>.
    button.querySelectorAll("svg, .fas, .far").forEach((icon) => {
      icon.classList.toggle("d-none")
    })
  })
}

export default { start }
